import { UserRound } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const placeholders = [0, 1, 2];

export const Team = () => (
    <section data-testid="team-section" className="py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <SectionHeading
                number="06"
                eyebrow="The Team"
                title="Your Dental Care"
                accent="Team"
                sub="A dedicated team focused on gentle, professional care. Team profiles will be added here soon."
            />
            <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3">
                {placeholders.map((i) => (
                    <Reveal key={i} delay={i * 0.1}>
                        <div
                            data-testid={`team-placeholder-${i}`}
                            className="group overflow-hidden rounded-3xl border border-dashed border-ink/20 bg-white"
                        >
                            <div className="grid aspect-[4/4] place-items-center rounded-b-none bg-mist transition-colors duration-500 group-hover:bg-teal-100">
                                <span className="grid h-24 w-24 place-items-center rounded-full border-2 border-dashed border-teal-600/40 text-teal-700">
                                    <UserRound className="h-10 w-10" />
                                </span>
                            </div>
                            <div className="p-6 text-center">
                                <p className="font-display text-xl text-ink">Dental Care Professional</p>
                                <p className="mt-1 text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
                                    Profile coming soon
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
